class OverlaySizes extends HTMLElement {
  constructor() {
    super();
    //the raw variant/product data
    this.data = [];

    //the list of sizes to render
    this.sizes = [];

    this.overlay = this.querySelector(".overlay-sizes");
    this.menu = this.overlay.querySelector(".overlay-sizes__menu");

    this.addEventListener("variants-ready", this.onMount.bind(this));    
    this.handleOverlaySizesHidden();
    this.setupEventListeners();
  }

  connectedCallback() {
    this.setData();
  }

  onMount() {
    this.setSizes();
    this.render();
  }

  setupEventListeners() {
    this.addEventListener("click", this.handleOverlaySizesDisplay);
    this.addEventListener("mouseover", this.handleOverlaySizesDisplay);
    this.addEventListener("mouseout", this.handleOverlaySizesHidden);
  }

  handleOverlaySizesDisplay = () => {
    if (!this.overlay) return;
    this.overlay.classList.remove("hidden");
    this.overlay.setAttribute("aria-hidden", false);
  };

  handleOverlaySizesHidden = () => {
    if (!this.overlay) return;
    this.overlay.classList.add("hidden");
    this.overlay.setAttribute("aria-hidden", true);
  };

  setData() {
    //INSIDR CHANGE
    if (this.dataset.variants.length === 0) return;
    const data = JSON.parse(this.dataset.variants).availableVariants;
    if (!data || !data?.length) return;

    // filter same color variants
    this.data = data.filter(
      (variant) =>
        variant.productId === `gid://shopify/Product/${this.dataset.productId}`
    );

    const event = new CustomEvent("variants-ready");
    this.dispatchEvent(event);
  }

  /*
    Sets the sizes data information
  */
  setSizes() {
    const sortedVariants = this.sortSizes(this.data);
    const removedVariants = this.removeDuplicateSizes(sortedVariants);
    const formattedSizes = this.formatSizes(removedVariants);
    this.sizes = formattedSizes;
  }

  /*
    Sorts the variant data by ranking them in order of size and best condition
  */
  sortSizes(variants = []) {
    return variants.toSorted((a, b) => {
      const aSizeRank = a.variant_data.size.rank;
      const aConditionRank = a.variant_data.condition.rank;
      const bSizeRank = b.variant_data.size.rank;
      const bConditionRank = b.variant_data.condition.rank;

      if (aSizeRank === bSizeRank) {
        // If both size and condition ranks are equal, then omit sorting.
        if (aConditionRank === bConditionRank) {
          return 0;
        } else {
          // If both condition ranks are different, then sort by condition rank.
          return aConditionRank < bConditionRank ? -1 : 1;
        }
      } else {
        // If both size ranks are different, sort by size rank.
        return aSizeRank < bSizeRank ? -1 : 1;
      }
    });
  }

  removeDuplicateSizes(variants = []) {
    const unique = [];
    for (const variant of variants) {
      const match = unique.find(
        (element) =>
          element.variant_data.size.code === variant.variant_data.size.code
      );
      if (!match) {
        unique.push(variant);
      }
    }
    return unique;
  }

  /*
    Sets the sizes formatting
  */
  formatSizes(variants = []) {
    return variants.map((variant) => {
      const formattedVariant = {};
      formattedVariant.handle = variant.handle;
      formattedVariant.display = variant.variant_data.size.display;
      formattedVariant.code = variant.variant_data.size.code;
      formattedVariant.rank = variant.variant_data.size.rank;
      formattedVariant.variantId = variant.variantId.split("/").slice(-1)[0];
      return formattedVariant;
    });
  }

  /*
    Generate the HTML for the overlay sizes menu
  */
  render() {
    const shouldAddSizes = !this.menu.children.length;
    if (!shouldAddSizes) {
      return;
    }

    const sizes = this.sizes;
    let markup = "";

    if (sizes) {
      sizes.forEach((size) => {
        markup += `
        <li>
          <a
            href="/products/${size.handle}/?variant=${size.variantId}"
            class="overlay-sizes__size"
            id="overlay-sizes__size-${size.code}"
            role="menuitem"
          >
            ${size.display}
          </a>
        </li>
        `;
      });
    }

    this.menu.insertAdjacentHTML("beforeend", markup);
  }
}

customElements.define("overlay-sizes", OverlaySizes);
